<template>
  <div
    class="FormDate "
    @keyup.capture="updateValue">
    <input
      v-if="showDay"
      ref="day"
      v-model="day"
      class="FormDate__input FormDate__input--day"
      type="number"
      placeholder="Tag"
      @input="updateDay"
      @blur="blurDay">
    <span
      v-if="showDay && showMonth"
      class="FormDate__divider"
    >.</span>
    <input
      v-if="showMonth"
      ref="month"
      v-model="month"
      class="FormDate__input FormDate__input--month"
      type="number"
      placeholder="Mo"
      @input="updateMonth"
      @blur="blurMonth">
    <span
      v-if="showYear && (showDay || showMonth)"
      class="FormDate__divider"
    >.</span>
    <input
      v-if="showYear"
      ref="year"
      v-model="year"
      class="FormDate__input FormDate__input--year"
      type="number"
      placeholder="Jahr"
      @input="updateYear"
      @blur="blurYear">
  </div>
</template>

<script>
export default {
  name: `FormDate`,
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
    showDay: {
      type: Boolean,
      default: true,
    },
    showMonth: {
      type: Boolean,
      default: true,
    },
    showYear: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      day: `${this.value ? new Date(this.value).getDate() : ``}`,
      month: `${this.value ? new Date(this.value).getMonth() + 1 : ``}`,
      year: `${this.value ? new Date(this.value).getFullYear(): ``}`,
    };
  },
  watch: {
    year( current/*, prev */) {
      //console.log('watch: ', current, new Date().getFullYear());
      
      if (Number.parseInt( current) >  new Date().getFullYear())
      { 
        this.year = ""+  new Date().getFullYear();
      }
    },
  },
  methods: {
    blurDay(){
      if(this.day == undefined || this.day ==''){
        //this.day = '01';

      }else{
        this.day = (this.day).padStart(2,0);
      }
      
    },
    updateDay() {
        //console.log('Day: ', this.day.length, this.day);
        
        if(!this.day.length || parseInt(this.day, 10) > 31){
            this.day = '31';
        } 

        if (!this.day.length || parseInt(this.day, 10) < 4) return;

        if (this.showMonth) this.$refs.month.select();
        else if (this.showYear) this.$refs.year.select();
    },
    blurMonth(){
      if (this.month == undefined || this.month =='') {
        //this.month = '1';
      }else{
        this.month = (this.month).padStart(2,0);
      }

    },
    updateMonth() {
      if(parseInt(this.month, 10) > 12){
        this.month = '12';
      }

      if (!this.month.length || parseInt(this.month, 10) < 2) return;

      if (this.showYear) this.$refs.year.select();
    },
    blurYear(){
      if(this.year == undefined || this.year =='' || (parseInt(this.year, 10) < 1900)){
        this.year = '1900';
      }else{
        this.year = (this.year).padStart(4,0)
      }
      
      
    },
    updateYear(){
      /* if{
        this.year = '1900';
      } */

    },
    updateValue() {
      //console.log('updateValue:', this.value);
      
      const timestamp = Date.parse(`${this.year.padStart(4, 0)}-${this.month}-${this.day}`);

      if (Number.isNaN(timestamp)) return;
      this.$emit(`input`, timestamp);
    },
    setDate(date){
      // make strings with padding "0"
      this.year = ""+  date.getFullYear();
      this.month = (""+  (date.getMonth()+1)).padStart(2,0);
      this.day = (""+ date.getDate()).padStart(2,0);

      this.updateValue();

    }
  },
  mounted(){
     //console.log('MountedValue:', this.value);
  }
};
</script>


<style scoped>
    .FormDate{display:inline-flex; position:relative; overflow:hidden; border: 1px solid #dee2e6; border-radius:0em}
    .FormDate__input{padding: 0em;padding-right:.375em;padding-left:.375em;border:none;text-align:center;-moz-appearance:textfield}
    .FormDate__input::-webkit-inner-spin-button{display:none}
    .FormDate__input:first-child{padding-left:.75em}
    .FormDate__input:last-child{padding-right:.75em}
    .FormDate__input:focus{outline:none}
    .FormDate__input--day,.FormDate__input--month{width:3em}
    .FormDate__input--year{width:4em}
    .FormDate__divider{padding-top:0.45em; padding-bottom:.45em;pointer-events:none}
</style>
